/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { SublistSynonymsCell } from 'src/luis/verticals/entityDetails/components/listEntityDetails/SublistSynonymsCell';

export type QnaMakerSynonymsColumnRendererProps = {
    synonyms: string[];
    isInEditMode?: boolean;
    onEditSynonyms: (synonyms: string[]) => void;
};

/**
 * A component rendering the synonyms column in the edit page Synonyms.
 */
export const QnaMakerSynonymsColumnRenderer = (props: QnaMakerSynonymsColumnRendererProps) => {
    const { synonyms, onEditSynonyms, isInEditMode = false } = props;

    return (
        <SublistSynonymsCell
            isEditMode={isInEditMode && synonyms.length < 20}
            isRemovingDisabled={!isInEditMode}
            values={synonyms}
            onAddValues={values => onEditSynonyms([...synonyms, ...values])}
            onRemoveValues={values => onEditSynonyms(synonyms.filter(v => values.some(value => value !== v)))}
        />
    );
};
